module.exports = __webpack_public_path__ + "7c1ff163ae098a04cb41d59cfc93ab7c.pdf";